"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var short_uuid_1 = __importDefault(require("short-uuid"));
var client_v0_1 = __importDefault(require("./client_v0"));
var callback_manager_1 = __importDefault(require("./callback_manager"));
var ClientV1 = /** @class */ (function (_super) {
    __extends(ClientV1, _super);
    function ClientV1(server) {
        var _this = _super.call(this, server) || this;
        _this.game_events = [];
        _this._user_data_dict = {};
        _this.callbacks_ud = new callback_manager_1.default();
        _this.callbacks_ev = new callback_manager_1.default();
        return _this;
    }
    ClientV1.prototype.emitUserData = function (data) {
        var my_data = this._user_data_dict[this.user_id];
        // Add new data
        my_data = __assign(__assign({}, my_data), data);
        // Remove undefined
        Object.keys(my_data).forEach(function (key) { return my_data[key] === undefined ? delete my_data[key] : {}; });
        this._user_data_dict[this.user_id] = my_data;
        this._emitCustom('user-data', data);
    };
    ClientV1.prototype.onUserData = function (cb) {
        return this.callbacks_ud.add('main', cb);
    };
    ClientV1.prototype.offUserData = function (cb) {
        if (cb === void 0) { cb = null; }
        this.callbacks_ud.rm('main', cb);
    };
    Object.defineProperty(ClientV1.prototype, "user_data", {
        get: function () {
            var _this = this;
            return this.user_list.map(function (user_id) {
                var data = _this._user_data_dict[user_id];
                if (!data)
                    data = {};
                return __assign({ _user_id: user_id }, data);
            });
        },
        enumerable: true,
        configurable: true
    });
    ClientV1.prototype.emitGameEvent = function (data) {
        var code = short_uuid_1.default.generate().toLowerCase().substring(0, 4);
        var event_id = 'e-' + this.user_idx + '-' + this.game_events.length + '-' + code;
        var event = { event_id: event_id, user_id: this.user_id, data: data };
        this._emitCustom('game-event', event);
        this._addGameEvent(event);
    };
    ClientV1.prototype._addGameEvent = function (event) {
        var _this = this;
        var event_id = event.event_id, user_id = event.user_id, data = event.data;
        // Skip repeated events
        for (var i = 0; i < this.game_events.length; i++) {
            if (this.game_events[i].event_id === event_id)
                return;
        }
        var copy = {
            event_id: event_id,
            user_id: user_id,
            processed: false,
            data: data
        };
        this.game_events.push(copy);
        this.game_events.forEach(function (event) {
            if (event.processed)
                return;
            event.processed = true;
            _this.callbacks_ev.run('main', event.data, event.user_id);
        });
    };
    ClientV1.prototype.onGameEvent = function (cb) {
        return this.callbacks_ev.add('main', cb);
    };
    ClientV1.prototype.offGameEvent = function (cb) {
        if (cb === void 0) { cb = null; }
        this.callbacks_ev.rm('main', cb);
    };
    ClientV1.prototype._onCustom = function (msg) {
        var user_id = msg.user_id, type = msg.type, data = msg.data;
        switch (type) {
            case 'user-data':
                return this._onUserData(user_id, data);
            case 'game-event':
                return this._onGameEvent(user_id, data);
        }
        _super.prototype._onCustom.call(this, msg);
    };
    ClientV1.prototype._onUserData = function (user_id, data) {
        var other_data = this._user_data_dict[user_id];
        other_data = __assign(__assign({}, other_data), data);
        Object.keys(other_data).forEach(function (key) { return other_data[key] === undefined ? delete other_data[key] : {}; });
        this._user_data_dict[user_id] = other_data;
        this.callbacks_ud.run('main', this.user_data);
    };
    ClientV1.prototype._onGameEvent = function (user_id, event) {
        this._addGameEvent(event);
    };
    ClientV1.prototype._onUserList = function (data) {
        var _this = this;
        _super.prototype._onUserList.call(this, data);
        // Reset my data so everybody has it (for late joins)
        var my_data = this.user_data[this.user_idx];
        this.emitUserData(my_data);
        // Resend events
        this.game_events.forEach(function (event) {
            _this._emitCustom('game-event', event);
        });
    };
    ClientV1.prototype.disconnect = function () {
        this.callbacks_ev.rmAll();
        this.callbacks_ud.rmAll();
        _super.prototype.disconnect.call(this);
    };
    return ClientV1;
}(client_v0_1.default));
exports.default = ClientV1;
